import { TransformNode, Mesh, Node } from '@babylonjs/core';
import { util } from './util';

export enum HelpPointType {
    LEFT,
    RIGHT,
    UP,
    DOWN,
}

export class HelpPoint {

    public static create(meshes: Mesh[]): HelpPoint[] {
        return util.flatMap(meshes, (mesh: Mesh) => {
            return mesh.getChildren((node: Node) => {
                return (
                    node instanceof TransformNode &&
                    node.name.includes('help')
                );
            }, false)
                .map((x: Node) => {
                    const node = x as TransformNode;
                    return new HelpPoint(node);
                });
        });
    }

    public type!: HelpPointType;

    public get isVertical(): boolean {
        return (
            this.type === HelpPointType.LEFT ||
            this.type === HelpPointType.RIGHT
        );
    }

    constructor(
        public node: TransformNode,
    ) {
        this.assignType();
    }

    private assignType() {
        const name = this.node.name;
        if (name.includes('L')) { this.type = HelpPointType.RIGHT; }
        if (name.includes('P')) { this.type = HelpPointType.LEFT; }
        if (name.includes('up')) { this.type = HelpPointType.UP; }
        if (name.includes('down')) { this.type = HelpPointType.DOWN; }
    }
}
